module.exports = __webpack_public_path__ + "static/media/icon_protector.b9fd609b.svg";